import { render, staticRenderFns } from "./comppricing.vue?vue&type=template&id=9de33bf4"
import script from "./comppricing.vue?vue&type=script&lang=js"
export * from "./comppricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports